import {useReducer} from "react";
import {formatDate} from "../utils/date";
import {useQuery} from "@tanstack/react-query";
import {statsApi} from "../services/statsService";

export const useStats = ({dispatch, filter}) => {
  const optionList = [
    {
      label: "Toute la période",
      onClick: (name) => {
        dispatch({
          type: name,
          payload: {
            from: "",
            to: "",
          },
        });
      },
    },
    {
      label: "Aujourd'hui",
      onClick: (name) => {
        const today = new Date();
        dispatch({
          type: name,
          payload: {
            from: formatDate(today, "YYYY-MM-DD"),
            to: formatDate(today.setDate(today.getDate() + 1), "YYYY-MM-DD"),
          },
        });
      },
    },
    {
      label: "Hier",
      onClick: (name) => {
        const today = new Date();
        // Move the date to yesterday
        today.setDate(today.getDate() - 1);
        dispatch({
          type: name,
          payload: {
            from: formatDate(today, "YYYY-MM-DD"),
            to: formatDate(today, "YYYY-MM-DD"), // End of yesterday
          },
        });
      },
    },
    {
      label: "Cette Semaine",
      onClick: (name) => {
        const today = new Date();
        const firstDayOfWeek = today.getDate() - today.getDay(); // Sunday
        const lastDayOfWeek = firstDayOfWeek + 6; // Saturday
        const startOfWeek = new Date(today.setDate(firstDayOfWeek));
        const endOfWeek = new Date(today.setDate(lastDayOfWeek));
        dispatch({
          type: name,
          payload: {
            from: formatDate(startOfWeek, "YYYY-MM-DD"),
            to: formatDate(endOfWeek, "YYYY-MM-DD"),
          },
        });
      },
    },
    {
      label: "Ce Mois",
      onClick: (name) => {
        const today = new Date();
        const firstDayOfMonth = new Date(
          today.getFullYear(),
          today.getMonth(),
          1,
        );
        const lastDayOfMonth = new Date(
          today.getFullYear(),
          today.getMonth() + 1,
          0,
        );
        dispatch({
          type: name,
          payload: {
            from: formatDate(firstDayOfMonth, "YYYY-MM-DD"),
            to: formatDate(lastDayOfMonth, "YYYY-MM-DD"),
          },
        });
      },
    },
    {
      label: "Cette Année",
      onClick: (name) => {
        const today = new Date();
        const firstDayOfYear = new Date(today.getFullYear(), 0, 1);
        const lastDayOfYear = new Date(today.getFullYear(), 11, 31);
        if (name === "Revenue") {
          dispatch({
            type: name,
            payload: {
              year: today.getFullYear(),
            },
          });
        } else {
          dispatch({
            type: name,
            payload: {
              from: formatDate(firstDayOfYear, "YYYY-MM-DD"),
              to: formatDate(lastDayOfYear, "YYYY-MM-DD"),
            },
          });
        }
      },
    },
    //  {
    //    label: "Choisir la date",
    //    onClick: (name) => {
    //      setFilterModal(name);
    //      toggleModal();
    //
    //    },
    //  },
  ];
  const {data, isLoading, isError} = useQuery({
    queryKey: ["stats", JSON.stringify(filter)],
    queryFn: () => statsApi.getStats({filter}),
  });

  return {
    data,
    isLoading,
    isError,

    optionList,
  };
};
